import SelectField from '../../../components/forms/SelectField';

const FirstTimePartnerOptions = ({
  disabled,
  data,
  onOrganizationChange,
  isLoadingOrganizations,
  organizations = []
}) => {
  return (
    <SelectField
      required
      label="Organisatie"
      value={data?.organization}
      isSubmitting={isLoadingOrganizations}
      onChange={onOrganizationChange}
      options={organizations}
      disabled={disabled}
    />
  );
};

export default FirstTimePartnerOptions;
